module.exports = __webpack_public_path__ + "img/minus.5863fc7a.svg";